/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Tip_TitleInputs */

const en_loading_tip_title = /** @type {(inputs: Loading_Tip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`While you wait: prepare your next step`)
};

const id_loading_tip_title = /** @type {(inputs: Loading_Tip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sambil menunggu: siapkan langkah berikutnya`)
};

/**
* | output |
* | --- |
* | "While you wait: prepare your next step" |
*
* @param {Loading_Tip_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_tip_title = /** @type {((inputs?: Loading_Tip_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Tip_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_tip_title(inputs)
	return en_loading_tip_title(inputs)
});